<template>
    <ViewDemandePrix/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
import ViewDemandePrix from "@/components/GesCom/DemandePrix/ViewDemandePrix.vue";

    export default defineComponent({
      name: "ViewDemandePrixPage",
      components: {
        
        ViewDemandePrix,
      },
    });
  </script>